<div class="row g-0" *ngIf="title" mat-cell>
  <div class="col">
    <div class="center-text list-title mb-4">
      <h4>{{ title }}</h4>
    </div>
  </div>
</div>

<!--Filters-->
<mat-form-field class="w-100" appearance="outline">
  <mat-icon matSuffix>search</mat-icon>
  <mat-label>{{ filter?.filterPlaceholder }}</mat-label>
  <input
    matInput
    [placeholder]="filter?.filterPlaceholder"
    autocomplete="off"
    type="text"
    [(ngModel)]="listFilter"
    name="Filter"
    (input)="applyFilters()"
  />
</mat-form-field>

<!--Selected action button-->
<div class="d-flex my-3" *ngIf="selectable">
  <a
    mat-flat-button
    color="accent"
    (click)="emitSelectedItemsAction()"
    [matTooltip]="selectedItemsButtonText"
    matTooltipPosition="below"
    matTooltipShowDelay="1000"
  >
    {{ selectedItemsButtonText }}
  </a>
</div>

<div class="loading-shade" *ngIf="loading">
  <mat-spinner></mat-spinner>
</div>

<!--Top Pagination-->
<mat-paginator
  *ngIf="pagination.enable && listToDisplay.length > 0 && pagination.topPagination"
  showFirstLastButtons
  [length]="filteredData.length"
  [pageSize]="pagination.elementsPerPage"
  (page)="handlePageChange($event)"
  [pageIndex]="currentPage"
  [hidePageSize]="true"
  aria-label="Select page of periodic elements"
>
</mat-paginator>

<table mat-table [dataSource]="listToDisplay" class="mat-elevation-z4 w-100 list-table">
  <!-- Columns -->
  <ng-container *ngFor="let field of displayFields" [matColumnDef]="field.name">
    <th mat-header-cell *matHeaderCellDef [ngStyle]="field?.headerStyle">
      <span *ngIf="field.type != 'checkbox'">
        <span *ngIf="field.type == 'custom'"></span>
        <span *ngIf="field.type != 'custom'" class="names">{{ field.name }}</span>
      </span>

      <mat-checkbox *ngIf="field.type == 'checkbox'" [checked]="selectAllCheckbox" (change)="checkAllItems()">
      </mat-checkbox>

      <mat-icon
        class="pt-2"
        [matTooltip]="'list.order_tooltip' | translate: { value: field.name }"
        matTooltipPosition="right"
        matTooltipShowDelay="1000"
        *ngIf="sortableFields.includes(field.name) && currentField == field.property && currentDirection == 1"
        (click)="orderColumn(field.property, -1)"
        >keyboard_arrow_up</mat-icon
      >

      <mat-icon
        class="pt-2"
        [matTooltip]="'list.order_tooltip' | translate: { value: field.name }"
        matTooltipPosition="right"
        matTooltipShowDelay="1000"
        *ngIf="sortableFields.includes(field.name) && currentField == field.property && currentDirection == -1"
        (click)="orderColumn('', 0)"
        >keyboard_arrow_down</mat-icon
      >

      <mat-icon
        class="pt-2"
        [matTooltip]="'list.order_tooltip' | translate: { value: field.name }"
        matTooltipPosition="right"
        matTooltipShowDelay="1000"
        *ngIf="sortableFields.includes(field.name) && currentField != field.property"
        (click)="orderColumn(field.property, 1)"
        >remove</mat-icon
      >
    </th>

    <td mat-cell *matCellDef="let item" [ngStyle]="item['contentStyle'][field.property]">
      <mat-checkbox *ngIf="field.type == 'checkbox'" [checked]="item['selected']" (change)="checkboxChanged(item)">
      </mat-checkbox>

      <span class="string-field" *ngIf="field.type == 'string'">{{ resolveObjectProperty(item, field.property) }}</span>

      <span *ngIf="field.type == 'datetime'">{{
        resolveObjectProperty(item, field.property) | date: 'd-MMM-y, hh:mm'
      }}</span>

      <span *ngIf="field.type == 'number'">{{ resolveObjectProperty(item, field.property) | number: '1.0-0' }}</span>
      <!-- <span *ngIf="field.type == 'boolean'"
              class="{{resolveObjectProperty(item, field.property) | boolean: field.style['control']:'boolean_vis_true' : 'boolean_vis_false'}}">
              <span class="boolean_text">{{resolveObjectProperty(item, field.property) | boolean:
                field.style['control']:
                resolveObjectProperty(item,field.style['true']):resolveObjectProperty(item,field.style['false'])}}
              </span>
            </span> -->

      <span
        *ngIf="field.type == 'boolean_string'"
        class="{{
          resolveObjectProperty(item, field.property)
            | boolean: field.style['control']:field.style['trueClassState']:field.style['falseClassState']
        }}"
      >
        <span class="boolean_text">
          {{
            resolveObjectProperty(item, field.property)
              | boolean: field.style['control']:field.style['trueStateViewValue']:field.style['falseStateViewValue']
          }}
        </span>
      </span>

      <div *ngIf="field.type == 'custom'">
        <ng-container
          *ngIf="customFieldTemplateRef"
          [ngTemplateOutlet]="customFieldTemplateRef"
          [ngTemplateOutletContext]="{ $implicit: item }"
        >
        </ng-container>
      </div>
    </td>
  </ng-container>

  <tr
    mat-header-row
    *matHeaderRowDef="displayedColumns"
    [ngClass]="{ 'hidden-headers': listToDisplay.length == 0 }"
  ></tr>

  <tr
    mat-row
    *matRowDef="let row; columns: displayedColumns"
    [ngClass]="{ 'clickable-row': clickableRows, 'row-selected': row['selected'] }"
    (click)="rowClickedEmit(row)"
  ></tr>

  <tr *matNoDataRow>
    <td class="mat-cell" [attr.colspan]="displayedColumns.length">
      <h5 class="mt-4 mb-3 text-center">{{ 'common.no_data' | translate }}</h5>
    </td>
  </tr>
</table>

<!--Bottom Pagination-->
<mat-paginator
  *ngIf="pagination.enable && listToDisplay.length > 0 && pagination.bottomPagination"
  showFirstLastButtons
  [length]="filteredData.length"
  [pageSize]="pagination.elementsPerPage"
  (page)="handlePageChange($event)"
  [pageIndex]="currentPage"
  [hidePageSize]="true"
  aria-label="Select page of periodic elements"
>
</mat-paginator>
